// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"VolumeSlider_sliderWrapper__QbOCa","range":"VolumeSlider_range__Fb0Wq"};